import {
  Autocomplete,
  CardMedia,
  Checkbox,
  FormControl,
  FormControlLabel,
  Grid,
  TextField,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import clsx from "clsx";
import { isEmpty } from "lodash";
import React, { memo, useEffect } from "react";
import CancelIcon from "@mui/icons-material/Cancel";
import { getData } from "../../utils/GlobalHelper";
const useStyle = makeStyles({
  fontDB: {
    fontFamily: "DB Heavent !important",
  },
  fontNormal: {
    fontWeight: "normal !important",
  },
  hide: {
    display: "none",
  },
});
const choice14 = {
  SAfsa14_Id: -1,
  positionName: "",
  companyName: "",
  expFrom: "",
  expTo: "",
  Delflag: "",
};
const CheckboxList = (props) => {
  const classes = useStyle();
  const {
    SAfsac_Remark,
    SAfsac_Remark2,
    SAfsac_SubAnswer,
    answerjson14,
    onChangeAnswerjson14,
    SAfsac_SAmsa_Id,
    SAfsac_Answer,
    Answer,
    Answer2,
    SubAnswer,
    TextAnswer,
    handleChange,
    handleChangeRemark,
    handleChangeRemark2,
  } = props;
  const lang = getData("lang");
  const getYearTH = () => {
    let year = [];
    const YEAR = new Date().getFullYear() + 543;
    for (let index = YEAR; index > YEAR - 100; index--) {
      year.push({
        label: index.toString(),
        value: (index - 543).toString(),
      });
    }
    return year;
  };
  const getYear = () => {
    let year = [];
    const YEAR = new Date().getFullYear();
    for (let index = YEAR; index > YEAR - 100; index--) {
      year.push({
        label: index.toString(),
        value: index.toString(),
      });
    }
    return year;
  };
  const getYearTo = (date) => {
    let year = [];
    const YEAR = new Date(date).getFullYear();
    const YEAR_LOC = new Date().getFullYear();
    for (let index = YEAR_LOC; index >= YEAR; index--) {
      year.push({
        label: index.toString(),
        value: index.toString(),
      });
    }
    return year;
  };
  const onAddSubAnswer = () => {
    if (answerjson14.length <= 2) {
      let data = [...answerjson14];
      data.push({ ...choice14 });
      onChangeAnswerjson14(data);
    }
  };
  const onChangeCompanyStart = (e, key) => {
    let data = [...answerjson14];
    data[key].expFrom = e?.value;
    data[key].expTo = "";
    onChangeAnswerjson14([...data]);
  };
  const onChangeCompanyEnd = (e, key) => {
    let data = [...answerjson14];
    data[key].expTo = e?.value;
    onChangeAnswerjson14([...data]);
  };
  const exitAnswer14 = (key) => {
    if (answerjson14.length > 1) {
      let data = [...answerjson14];
      let newAns = [];
      data.forEach((ans, i) => {
        if (i !== key) {
          newAns.push({ ...ans });
        }
      });
      onChangeAnswerjson14([...newAns]);
    }
  };
  const changePositionName = (e, key) => {
    let data = [...answerjson14];
    data[key].positionName = e.target.value;
    onChangeAnswerjson14([...data]);
  };
  const changeCompanyName = (e, key) => {
    let data = [...answerjson14];
    data[key].companyName = e.target.value;
    onChangeAnswerjson14([...data]);
  };
  const handleChangeCheck = (e) => {
    if (e.target.checked) {
      let str = "";
      SAfsac_SubAnswer.forEach((sub) => {
        str = str ? str + "_" + sub : sub;
      });
      str = str ? str + "_" + e.target.value : e.target.value;
      let sub = {
        SAfsac_SubAnswer: str,
      };
      handleChange(sub);
    } else {
      let str = "";
      SAfsac_SubAnswer.forEach((sub) => {
        if (sub.toString() !== e.target.value) {
          str = str ? str + "_" + sub : sub !== "" ? sub : "";
        }
      });
      let sub = {
        SAfsac_SubAnswer: str,
      };
      handleChange(sub);
    }
  };
  const UiSubAnswer = (qus, key) =>
    !isEmpty(SubAnswer) && (
      <Grid>
        <Grid
          container
          direction="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <Grid item xs="auto">
            <Grid className="font-DBHeavent font-20 text-primary">
              {SubAnswer.Text
                ? SubAnswer.Text
                : "ความรู้ประสบการณ์ " + (key + 1)}
            </Grid>
          </Grid>
          <Grid item xs="auto">
            {key > 0 && (
              <CancelIcon
                color="error"
                className="text-pointer"
                onClick={() => exitAnswer14(key)}
              />
            )}
          </Grid>
        </Grid>

        <Grid>
          <Grid className="input-form">
            <FormControl variant="standard" fullWidth>
              <TextField
                className="font-20"
                label={SubAnswer?.Answer?.[0]?.Text.split("<")[0]}
                variant="standard"
                onChange={(e) => changePositionName(e, key)}
                value={qus.positionName}
              />
            </FormControl>
          </Grid>
        </Grid>
        <Grid>
          <Grid className="input-form">
            <FormControl variant="standard" fullWidth>
              <TextField
                className="font-20"
                label={SubAnswer?.Answer?.[1]?.Text.split("<")[0]}
                variant="standard"
                onChange={(e) => changeCompanyName(e, key)}
                value={qus.companyName}
              />
            </FormControl>
          </Grid>
        </Grid>
        <Grid>
          <Grid className="input-form">
            <FormControl variant="standard" fullWidth>
              <Autocomplete
                size="small"
                options={getYear()}
                value={
                  !isEmpty(qus.expFrom)
                    ? { label: qus.expFrom, value: qus.expFrom }
                    : null
                }
                getOptionLabel={(option) => (option.label ? option.label : "")}
                onChange={(e, value) => onChangeCompanyStart(value, key)}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="standard"
                    label={SubAnswer?.Answer?.[2]?.Text.split("<")[0]}
                  />
                )}
              />
            </FormControl>
          </Grid>
        </Grid>
        <Grid>
          <Grid className="input-form">
            <FormControl variant="standard" fullWidth>
              <Autocomplete
                disabled={isEmpty(qus.expFrom)}
                size="small"
                options={getYearTo(qus.expFrom)}
                getOptionLabel={(option) => (option.label ? option.label : "")}
                value={
                  !isEmpty(qus.expTo)
                    ? { label: qus.expTo, value: qus.expTo }
                    : null
                }
                onChange={(e, value) => onChangeCompanyEnd(value, key)}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="standard"
                    label={SubAnswer?.Answer?.[3]?.Text.split("<")[0]}
                  />
                )}
              />
            </FormControl>
          </Grid>
        </Grid>
      </Grid>
    );
  useEffect(() => {
    if (answerjson14.length === 0) {
      onChangeAnswerjson14([{ ...choice14 }]);
    }
  }, []);
  return (
    !isEmpty(Answer) && (
      <Grid
        className={clsx(
          SAfsac_Answer.toString() !== "1" ? classes.hide : "",
          "pb-4"
        )}
      >
        <FormControl style={{ width: "100%" }}>
          {Answer?.map((row, i) => (
            <Grid className="checkbox-consent" key={i}>
              <FormControlLabel
                key={i}
                onChange={(e) => handleChangeCheck(e)}
                value={row?.AnswerID}
                classes={{
                  label: clsx(
                    classes.fontDB,
                    "text-black",
                    classes.fontNormal,
                    "font-20"
                  ),
                }}
                className="b-bottom pl-3 pr-3 fullWidth"
                control={
                  <Checkbox
                    checked={SAfsac_SubAnswer?.includes("" + row?.AnswerID)}
                  />
                }
                label={row?.Text.split("<")[0]}
              />
              {/* <Checkbox
                checked={SAfsac_SubAnswer?.includes("" + row?.AnswerID)}
                onChange={(e) => handleChangeCheck(e)}
                value={row?.AnswerID}
              />
              <Grid
                onClick={(e) => {
                  if (SAfsac_SubAnswer?.includes("" + row?.AnswerID)) {
                    let str = "";
                    SAfsac_SubAnswer?.forEach((sub) => {
                      if (sub.toString() !== row?.AnswerID) {
                        str = str ? str + "_" + sub : sub;
                      }
                    });
                    let sub = {
                      SAfsac_SubAnswer: str,
                    };
                    handleChange(sub);
                  } else {
                    let str = "";
                    SAfsac_SubAnswer?.forEach((sub) => {
                      str = str ? str + "_" + sub : sub;
                    });
                    str = str ? str + "_" + row?.AnswerID : row?.AnswerID;
                    let sub = {
                      SAfsac_SubAnswer: str,
                    };
                    handleChange(sub);
                  }
                }}
                className={clsx(
                  "font-DBHeavent",
                  "text-black",
                  classes.fontNormal,
                  "font-20",
                  "pt-2"
                )}
              >
                {row?.Text.split("<")[0]}
              </Grid> */}
            </Grid>
          ))}
          {!isEmpty(TextAnswer) ? (
            <Grid className="pt-2 pb-2 pl-5 pr-5 ">
              <Grid className="font-DBHeavent font-20 text-primary font-weight-bold">
                {TextAnswer}
              </Grid>
              {!isEmpty(Answer2) && (
                <Grid>
                  <Grid className="input-form">
                    <FormControl variant="standard" fullWidth>
                      <TextField
                        className="font-20"
                        label={Answer2[0].Text.split("<")[0]}
                        onChange={handleChangeRemark}
                        value={SAfsac_Remark}
                        variant="standard"
                      />
                    </FormControl>
                  </Grid>
                  <Grid className="input-form">
                    <FormControl variant="standard" fullWidth>
                      <Autocomplete
                        size="small"
                        options={lang === "th" ? getYearTH() : getYear()}
                        getOptionLabel={(option) =>
                          option.label ? option.label : ""
                        }
                        value={
                          !isEmpty(SAfsac_Remark2)
                            ? {
                                label:
                                  lang === "th"
                                    ? (
                                        parseInt(SAfsac_Remark2) + 543
                                      ).toString()
                                    : SAfsac_Remark2,
                                value:
                                  lang === "th"
                                    ? SAfsac_Remark2
                                    : SAfsac_Remark2,
                              }
                            : null
                        }
                        onChange={(e, value) => handleChangeRemark2(value)}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            variant="standard"
                            label={Answer2[1].Text.split("<")[0]}
                          />
                        )}
                      />
                    </FormControl>
                  </Grid>
                </Grid>
              )}
            </Grid>
          ) : (
            SAfsac_SAmsa_Id !== 33 &&
            SAfsac_SAmsa_Id !== 29 && (
              <Grid
                className={clsx(
                  SAfsac_SubAnswer?.includes("" + 5) ? "" : classes.hide
                )}
                sx={{ marginTop: "-10px", paddingLeft: "50px" }}
              >
                <Grid>
                  <Grid className="input-form">
                    <FormControl variant="standard" fullWidth>
                      <TextField
                        className="font-20"
                        label="อื่นๆ"
                        onChange={handleChangeRemark}
                        value={SAfsac_Remark}
                        variant="standard"
                      />
                    </FormControl>
                  </Grid>
                </Grid>
              </Grid>
            )
          )}
          {!isEmpty(SubAnswer) && (
            <Grid
              className={clsx(
                SAfsac_SubAnswer?.includes("" + 15) ? "" : classes.hide,
                "pt-2 pb-2 pl-5 pr-5 "
              )}
            >
              {answerjson14?.map((qus, i) => (
                <Grid key={i}>{UiSubAnswer(qus, i)}</Grid>
              ))}
              <Grid
                className={clsx(
                  "btn-suit",
                  answerjson14.length === 3 && "hide"
                )}
                onClick={onAddSubAnswer}
              >
                <Grid
                  className=" text-primary"
                  container
                  direction="row"
                  justifyContent="space-around"
                  alignItems="center"
                >
                  <Grid item xs={2}>
                    <CardMedia
                      component="img"
                      sx={{ width: 25 }}
                      image="../../../images/plus.png"
                      alt="plus"
                    />
                  </Grid>
                  <Grid item xs={10}>
                    เพิ่มประสบการณ์อื่น ๆ
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          )}
        </FormControl>
      </Grid>
    )
  );
};
export default memo(CheckboxList);
